<template>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-sm-2">

        <label>Cd Crtor</label>

        <b-form-group :invalid-feedback="violations['cdCrtor']" :state="!violations['']">

          <b-form-input v-model="ssv2308ExcecRadarCotac.cdCrtor" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Tp Excec</label>

        <b-form-group :invalid-feedback="violations['tpExcec']" :state="!violations['']">

          <select class="custom-select" v-model="ssv2308ExcecRadarCotac.tpExcec" placeholder="Tipo de Exceção" :required="true" :readonly="false">
            <option></option>

            <option value="B">Bloqueado</option>

            <option value="N">Não Valida</option>

            <option value="L">Limite Alterado</option>

          </select>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Qt Limit Callo</label>

        <b-form-group :invalid-feedback="violations['qtLimitCallo']" :state="!violations['']">

          <b-form-input v-model="ssv2308ExcecRadarCotac.qtLimitCallo" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Qt Limit Callo Cotac</label>

        <b-form-group :invalid-feedback="violations['qtLimitCalloCotac']" :state="!violations['']">

          <b-form-input v-model="ssv2308ExcecRadarCotac.qtLimitCalloCotac" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Dt Ultma Alter</label>

        <b-form-group :invalid-feedback="violations['dtUltmaAlter']" :state="!violations['']">

          <date-picker v-model="ssv2308ExcecRadarCotac.dtUltmaAlter" type="date" value-type="format" lang="pt-br" format="DD/MM/YYYY" placeholder="" :required="true" :readonly="false"></date-picker>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Cd Usuro Ultma Alter</label>

        <b-form-group :invalid-feedback="violations['cdUsuroUltmaAlter']" :state="!violations['']">

          <b-form-input v-model="ssv2308ExcecRadarCotac.cdUsuroUltmaAlter" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import store from "@/store";
  
  import { 
  	
      } from "@/store/actions.type";
      
  export default {
    props: ['ssv2308ExcecRadarCotac', 'violations'],
    computed: {
  	    ...mapGetters([
  	         
  	         ]),
    },
    methods:{
        
    },
    mounted(){
      
    }
  }
</script>